import ReactDOM from 'react-dom/client';
import App from './App';
import './fontello/css/fontello.css';
import { Providers } from './hooks';
import './index.css';

import * as Sentry from '@sentry/react';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-TQCXLVSG',
};
TagManager.initialize(tagManagerArgs);

Sentry.init({
  dsn: 'https://e22fdeb5f4e658481ddbc76271880cf3@o68818.ingest.sentry.io/4505985629159424',
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    }),
    new Sentry.Replay(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Providers>
    <App />
  </Providers>
);
